import { Pipe, PipeTransform } from '@angular/core';
import sum from 'lodash-es/sum';
import { DeviceErrors, ErrorKeys } from '../devices.models';
import { ImportColumns } from '../dialogs/add-devices-dialog/add-devices-dialog.component';

@Pipe({
    name: 'liebherrHasError',
})
export class HasErrorPipe implements PipeTransform {
    transform(column: ImportColumns, errors: DeviceErrors): boolean {
        return (
            {
                [ImportColumns.ROUTER_TYPE]: sum(
                    [ErrorKeys.routerTypeRequired, ErrorKeys.routerTypeInvalid, ErrorKeys.routerTypeVendorMatch].map(
                        (key) => errors[key] || 0
                    )
                ),
                [ImportColumns.SERIAL_NUMBER]: sum(
                    [ErrorKeys.serialNumber, ErrorKeys.serialNumberDuplicate].map((key) => errors[key] || 0)
                ),
                [ImportColumns.IMEI]: sum([ErrorKeys.imei, ErrorKeys.imeiDuplicate].map((key) => errors[key] || 0)),
                [ImportColumns.ICCID]: sum([ErrorKeys.iccid, ErrorKeys.iccidDuplicate].map((key) => errors[key] || 0)),
                [ImportColumns.SIM_EXPIRATION_DATE]: sum([ErrorKeys.date].map((key) => errors[key] || 0)),
                [ImportColumns.VENDOR]: sum([ErrorKeys.vendor, ErrorKeys.vendorRouterTypeMatch].map((key) => errors[key] || 0)),
            }[column] > 0
        );
    }
}
